import { gql } from '@apollo/client';

export const GET_GROUP_MEMBERS = gql`
	query getGroupMembers($groupID: ID!) {
		crewMemberSearch(filter: { groupsIds: [$groupID] }, pagination: { page: 0, size: 50 }) {
			results {
				id
				fullName
				driverCard
				currentHomeBase {
					city {
						name
					}
				}
				phone
			}
		}
	}
`;
